<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { FilterGlider } from '@/models/filter/FilterGlider'
import AdminGliderListLine from '@/components/admin/glider/AdminGliderListLine.vue'
import AdminGliderFilter from '@/components/admin/glider/AdminGliderFilter.vue'
import { AloDbGlider } from '@/models/alodb/AloDbGlider'

@Component({
  name: 'AdminGliderList',
  components: {AdminGliderListLine,AdminGliderFilter}
})

export default class AdminGliderList extends AdminList<AloDbGlider> {  
    
  get itemTypeName() {
    return "Glider"
  }

  get items()  {             
    return this.$store.myGetters.gliders.filter(g => 
      (this.filter.search.length == 0 ||  g.searchString!.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1) &&
      (this.filter.ownerIds.length == 0 || this.filter.ownerIds.indexOf(g.ENS_ID!) > -1)     
    )    
  }

  get componentFilterName() {
    return 'AdminGliderFilter'
  }

  get componentLineName(){
    return "AdminGliderListLine"
  } 

 
  get filter(){
    return this.$store.myGetters.adminGliderFilter
  }

  get nbFiltre() {    
    return this.filter.ownerIds.length + (this.filter.search.length > 0?1:0)
  }

  resetFilter() {
    this.$store.myActions.GLIDER_UPDATE_FILTER_ADM(new FilterGlider())
  }
}
</script>